import { type QuickFilter } from "./types";

export const QUICK_FILTERS: QuickFilter[] = [
  {
    id: "all-orders",
    name: "All Orders",
    sorting: [{ id: "date", desc: true }],
    filters: [],
  },
  {
    id: "new-customers",
    name: "New Customers",
    sorting: [{ id: "date", desc: true }],
    filters: [{ field: "orderTypes", value: ["First time"] }],
  },
  {
    id: "returning-customers",
    name: "Returning Customers",
    sorting: [{ id: "date", desc: true }],
    filters: [{ field: "orderTypes", value: ["Returning"] }],
  },
  {
    id: "full-price",
    name: "Full Price Purchase",
    sorting: [{ id: "date", desc: true }],
    filters: [
      {
        field: "discountValue",
        value: { value: 0, comparisonOperator: "equalTo" },
      },
    ],
  },
  {
    id: "subscriptions",
    name: "Subscriptions",
    sorting: [{ id: "date", desc: true }],
    filters: [
      { field: "subscriptions", value: ["FIRST_TIME", "RETURNING", "OTHER"] },
    ],
  },
  // {
  //   id: "longest-journey",
  //   name: "Longest Customer Journey",
  //   selectedTab: "breakdown",
  //   sorting: [{ id: "touchpointCount", desc: true }],
  //   filters: [],
  // },
  // {
  //   id: "shortest-journey",
  //   name: "Shortest Customer Journey",
  //   selectedTab: "breakdown",
  //   sorting: [{ id: "touchpointCount", desc: false }],
  //   filters: [],
  // },
  {
    id: "refunds",
    name: "Refunds",
    sorting: [{ id: "date", desc: true }],
    filters: [
      {
        field: "refundValue",
        value: { value: 0, comparisonOperator: "greaterThan" },
      },
    ],
  },
  {
    id: "highest-discounts",
    name: "Highest Discounts",
    sorting: [{ id: "discountValue", desc: true }],
    filters: [],
  },
  {
    id: "highest-value",
    name: "Highest Value",
    sorting: [{ id: "orderValue", desc: true }],
    filters: [],
  },
  {
    id: "unattributed",
    name: "Unattributed",
    sorting: [{ id: "date", desc: true }],
    filters: [{ field: "attributed", value: ["No"] }],
  },
];
